import { render, staticRenderFns } from "./ShowInvoices.vue?vue&type=template&id=b71a1464&scoped=true"
import script from "./ShowInvoices.vue?vue&type=script&lang=js"
export * from "./ShowInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71a1464",
  null
  
)

export default component.exports